import React, {useCallback, useMemo} from 'react';

import {BulkActionFooter} from 'src/components/bulk-tool/bulk-action-footer';
import {UserLink} from 'src/components/links';

import Button from '@pb/kit-component-button';
import {DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';


import {TOOL_TITLE} from './constants';

import type {ProcessBulkAction} from 'src/components/bulk-tool/typedef';
import type {ActionOptions} from 'src/components/save-with-reason/action-with-reason-button';
import type {RemoveManagerRequest} from 'src/openapi/admin/models/RemoveManagerRequest';
import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';

type Props = {
    accountTeamMember: UserShortInfo,
    accountIds: Array<number>,
    onCloseModal: (submit: boolean) => void,
    processAction: ProcessBulkAction<RemoveManagerRequest>,
};

export const RemoveAccountTeamMemberModal = ({accountIds, onCloseModal, processAction, accountTeamMember}: Props) => {
    const remove = useCallback(async (options?: ActionOptions) => {
        return await processAction({accountIds, managerId: accountTeamMember.userId}, options);
    }, [accountIds, accountTeamMember, processAction]);

    const userLink = useMemo(() => (
        <UserLink
            userId={accountTeamMember.userId}
            caption={[
                accountTeamMember.firstName,
                accountTeamMember.lastName,
            ].filter(Boolean).join(' ') || accountTeamMember.email}
            place={TOOL_TITLE}
        />
    ), [accountTeamMember]);

    return (
        <>
            <DialogHeader onClose={() => onCloseModal(false)}>
                {TOOL_TITLE}
            </DialogHeader>
            <DialogMain style={{padding: 24}}>
                Are you sure you want to remove {userLink} from the following accounts?
            </DialogMain>
            <BulkActionFooter action="Remove" onConfirm={remove}>
                <Group>

                    <Button variant="Type.SECONDARY" onClick={() => onCloseModal(false)}>
                        Cancel
                    </Button>
                </Group>
            </BulkActionFooter>
        </>
    );
};
